<template>
	<div>
		<table width="100%" class="mt-2 show-dialog-table">
			<tbody>
				<slot name="top-record" :rubber_process="rubberProcess" />
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'加工の種類'"
					:value="rubberProcessType ? rubberProcessType.name : ''"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'製造番号'"
					:value="
						rubberProcess.order_individual_info
							? rubberProcess.order_individual_info.full_product_number
							: ''
					"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'状態'"
					:value="rubberProcess.situation_i18n"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'作業チーム'"
					:value="rubberProcess.team ? rubberProcess.team.name : ''"
					:showEditBtn="rubberProcess.team && allowSelectTeam"
					@open-edit-dialog="openDialog('team')"
				>
					<template v-if="!rubberProcess.team && allowSelectTeam" v-slot:value>
						<v-btn small @click="openDialog('team')" color="secondary"> チームを設定する </v-btn>
					</template>
				</ShowDetailRecord>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'作業者'"
					:value="rubberProcess.processor ? rubberProcess.processor.full_name : ''"
					:showEditBtn="rubberProcess.processor && allowSelectTeam"
					@open-edit-dialog="openDialog('processor')"
				>
					<template v-if="!rubberProcess.processor && allowSelectTeam" v-slot:value>
						<v-btn small @click="openDialog('processor')" color="secondary">
							作業者を設定する
						</v-btn>
					</template>
				</ShowDetailRecord>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'機械'"
					:value="rubberProcess.machine ? rubberProcess.machine.name : ''"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'依頼量'"
					:value="rubberProcess.required_amount"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'加工開始予定日'"
					:value="
						common.formatDateWithNullableTime(
							rubberProcess,
							'schedule_start_date',
							'schedule_start_time'
						)
					"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'加工完了予定日'"
					:value="
						common.formatDateWithNullableTime(
							rubberProcess,
							'schedule_end_date',
							'schedule_end_time'
						)
					"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'加工開始日'"
					:value="common.formatDateWithNullableTime(rubberProcess, 'start_date', 'start_time')"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'加工完了日'"
					:value="common.formatDateWithNullableTime(rubberProcess, 'end_date', 'end_time')"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'備考'"
					:value="rubberProcess.memo"
					text
				/>
				<template v-if="rubberProcessType">
					<ShowDetailRecord
						v-for="(metaColumn, i) in rubberProcessType.all_meta_keys"
						:key="i"
						:tdStyle="tdStyle"
						:thStyle="thStyle"
						:fontSize="fontSize"
						:columnName="
							metaColumn.status == 'archived'
								? `${metaColumn.name} (アーカイブ済み)`
								: metaColumn.name
						"
						:text="metaColumn.data_type == 'text'"
						:value="value(metaColumn)"
					/>
				</template>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'登録者'"
					:value="rubberProcess.user ? rubberProcess.user.full_name : ''"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'登録日'"
					:value="common.formatDateTime(rubberProcess.created_at)"
				/>
				<ShowDetailRecord
					:tdStyle="tdStyle"
					:thStyle="thStyle"
					:fontSize="fontSize"
					:columnName="'最終更新日'"
					:value="common.formatDateTime(rubberProcess.updated_at)"
				/>
				<slot name="bottom-record" :rubber_process="rubber_process" />
				<tr height="8px" />
			</tbody>
		</table>
		<h4 class="mt-4 text-body-1 font-weight-bold secondary--text">加工素材情報</h4>
		<template v-if="rubberProcess.rubber_process_sources.length">
			<table width="100%" class="mt-2 show-dialog-table">
				<tbody v-for="source in rubberProcess.rubber_process_sources" :key="source.id">
					<ShowDetailRecord :columnName="'加工素材'" :value="source.target.name">
						<template v-slot:column="{ columnName }">
							{{ columnName }}
							<HelpComment
								v-if="source.rubber_process_type_source.memo"
								:text="source.rubber_process_type_source.memo"
								:btnClassArray="['ml-2']"
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'使用量'" :value="source.amount" />
					<ShowDetailRecord :columnName="'備考'" :value="source.memo" text />
					<tr height="8px" />
				</tbody>
			</table>
		</template>
		<p v-else class="text-body-2 mt-2">加工素材情報はありません</p>
		<h4 class="mt-4 text-body-1 font-weight-bold secondary--text">成果物情報</h4>
		<template v-if="rubberProcess.rubber_process_deliverables">
			<table width="100%" class="mt-2 show-dialog-table">
				<tbody
					v-for="deliverable in rubberProcess.rubber_process_deliverables"
					:key="deliverable.id"
				>
					<ShowDetailRecord
						:columnName="deliverable.main_flag ? 'メイン成果物' : '成果物'"
						:value="deliverable.target.name"
					>
						<template v-slot:column="{ columnName }">
							{{ columnName }}
							<HelpComment
								v-if="deliverable.rubber_process_type_deliverable.memo"
								:text="deliverable.rubber_process_type_deliverable.memo"
								:btnClassArray="['ml-2']"
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'完了数量'" :value="deliverable.amount" />
					<ShowDetailRecord :columnName="'備考'" :value="deliverable.memo" text />
					<tr height="8px" />
				</tbody>
			</table>
		</template>
		<p v-else class="text-body-2 mt-2">成果物情報はありません</p>
		<v-dialog
			v-model="dialog"
			max-width="700px"
			height="90%"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card>
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">チーム変更</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="dialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>
				<v-sheet elevation="0" class="pa-2">
					<v-select
						v-if="dialogType == 'team'"
						class="mt-4"
						label="チーム"
						v-model="team_id"
						:items="teams"
						item-value="id"
						item-text="name"
						outlined
						dense
						@change="changeTeam"
					/>
					<v-select
						class="mt-4"
						label="作業者"
						v-model="processor_id"
						:items="processors"
						item-value="id"
						item-text="full_name"
						outlined
						dense
					/>
				</v-sheet>
				<v-row no-gutters justify="center" class="pb-4">
					<v-btn color="secondary" class="mt-4" @click="updateRubberProcess()">
						<v-icon class="mr-1">mdi-pencil</v-icon>
						変更する
					</v-btn>
				</v-row>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import HelpComment from "../../shared/HelpComment.vue"
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"

export default {
	props: {
		rubber_process: {
			type: Object,
			required: true,
		},
		rubber_process_type: {
			type: Object,
			required: false,
		},
		tdStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		thStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		thStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		fontSize: {
			type: String,
			required: false,
			default: "",
		},
		showEditBtn: {
			default: false,
		},
		teams: {
			type: Array,
			required: false,
			default: () => [],
		},
		allowSelectTeam: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		HelpComment,
	},
	data() {
		return {
			rubberProcess: this.rubber_process,
			rubberProcessType: null,
			team_id: null,
			processor_id: null,
			dialogType: null,
			dialog: false,
			common,
		}
	},
	mounted() {
		this.rubberProcessType = this.rubber_process_type
			? this.rubber_process_type
			: this.rubber_process.rubber_process_type

		this.team_id = this.rubber_process.team_id
		this.processor_id = this.rubber_process.processor_id
	},
	methods: {
		value(metaColumn) {
			const value = this.rubberProcess.meta_values.find((v) => v.meta_column_id == metaColumn.id)
			return value ? common.value(metaColumn, value.value) : ""
		},
		openDialog(type) {
			this.dialogType = type
			this.dialog = true
		},
		changeTeam() {
			this.processor_id = null
		},
		updateRubberProcess() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber_processes/${this.rubberProcess.id}`
			const params = { rubber_process: { team_id: this.team_id, processor_id: this.processor_id } }
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.rubberProcess = res.data.rubber_process
					this.dialog = false
					this.$emit("update-rubber-process", this.rubberProcess)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		processors() {
			const team = this.teams.find((t) => t.id == this.team_id)
			return team ? team.users : []
		},
	},
	watch: {
		rubber_process(newVal, _) {
			this.rubberProcess = newVal
			this.team_id = newVal.team_id
			this.processor_id = newVal.processor_id
			if (!this.rubber_process_type)
				this.rubberProcessType = this.rubber_process.rubber_process_type
		},
		rubber_process_type(newVal, _) {
			this.rubberProcessType = newVal
		},
		deep: true,
	},
}
</script>